"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _icons = require("@ant-design/icons");

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Header.css");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Header Component for the Panel Component.
 * Normally, this component is not used directly,
 * but used by the Panel Component.
 *
 */
var Header = function Header(_ref) {
  var _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible,
      preTools = _ref.preTools,
      postTools = _ref.postTools,
      title = _ref.title,
      toggleCollapse = _ref.toggleCollapse,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      onClose = _ref.onClose,
      style = _ref.style;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "rolext-panel-header",
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut,
    style: style,
    children: [title, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        flex: 1
      },
      children: " "
    }), " ", preTools, " ", collapsible && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.DownOutlined, {
      style: {
        height: "100%"
      },
      className: "rolext-panel-header-collapse-tool rolext-panel-header-tool",
      onClick: toggleCollapse
    }), " ", onClose && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CloseOutlined, {
      style: {
        height: "100%"
      },
      className: "rolext-panel-header-collapse-tool rolext-panel-header-tool",
      onClick: onClose
    }), " ", postTools]
  });
};

Header.propTypes = {
  /**
   * If collapsible is true, the header will display 
   * a collapse/expand control that calls the callback
   * function passed in as the toggleCollapse property.
   */
  collapsible: _propTypes.default.bool,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown before the collapse/expand control.
   */
  preTools: _propTypes.default.node,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown in end, after the close control.
   */
  postTools: _propTypes.default.node,

  /**
   * a title text string
   */
  title: _propTypes.default.string.isRequired,

  /**
   * A callback function to be called once the
   * user clicks on the expand/collapse control.
   */
  toggleCollapse: _propTypes.default.func,

  /**
   * A callback function to be called once the
   * mouse is over the Header component.
   */
  onMouseOver: _propTypes.default.func,

  /**
   * A callback function to be called once the
   * mouse is moved out of the Header component.
   */
  onMouseOut: _propTypes.default.func,

  /**
   * A callback function to be called once the
   * user clicks in the close control.
   */
  onClose: _propTypes.default.func,

  /**
   * A CSS Style to render the Header
   */
  style: _propTypes.default.object
};
var _default = Header;
exports.default = _default;